import React from 'react';
import styled from 'styled-components';
import { token, Anchor } from '@zillow/constellation';
import { getCurrentUrl } from '../utils/windowUtils';

const ErrorWrapper = styled.div`
    background: ${token('colors.yellow100')};
    border: 1px solid ${token('colors.orange400')};
    padding: 0.5em;
`;

interface ErrorMessageProps {
    children: React.ReactNode;
    shouldShowRefreshPagePrompt?: boolean;
}

const ErrorMessage = ({ children, shouldShowRefreshPagePrompt = false }: ErrorMessageProps) => (
    <ErrorWrapper>
        <div>{children}</div>
        {shouldShowRefreshPagePrompt && (
            <div>
                Please <Anchor href={getCurrentUrl()}>refresh the page</Anchor> and try again.
            </div>
        )}
    </ErrorWrapper>
);

export default ErrorMessage;
